export default __webpack_public_path__ + "static/media/mouth.d5c80edf.png";